/**
 * External dependencies
 */
import { FC } from 'react';

/**
 * Internal dependencies
 */
import './HomeHeader.scss';
import ClutchWidget from 'components/ClutchWidget';
import ContentWithLink from '../ContentWithLink';
import sofa from 'images/team-images/sofa.jpg';

type HomeHeaderProps = {};

const HomeHeader: FC<HomeHeaderProps> = () => (
	<div className="home-header">
		<ContentWithLink
			button={{
				children: 'Check our work',
				to: '/about',
			}}
			content="Unlike the website your last developer created, ours <strong>won't require</strong> immediate fixes.<br>...and we reply to your messages."
			headline="No more of **chasing** your&nbsp;developer."
			headlineAlign="left"
			image={{
				src: sofa,
				title: 'Department of Web Team',
			}}
			imagePosition="top"
		/>
		<ClutchWidget />
	</div>
);

export default HomeHeader;
